import isNumber from 'lodash/isNumber';
import {Maybe} from '../graphql/generated/types';

export function isGreaterThanZero(num: Maybe<number>): num is number {
  return isNumber(num) && num > 0;
}
